import { useCanReadSuppliers } from '@/lib/supplierAccess';

/**
 * Route guard para la página de Proveedores. Espeja EXACTO el gate de lectura del
 * backend (canReadSuppliers = writeRoles OR any-of permisos) — NO un PermissionGuard
 * de solo any-of, que bloquearía al `manager` legacy que el backend SÍ deja leer.
 *
 * Mientras el user carga (`isLoading`) renderiza `null` para evitar el flash-of-redirect
 * (decidir con role/permissions vacíos mandaría a `/` a un usuario autorizado).
 */
export function SupplierReadGuard({ children, fallback = null }) {
  const { allowed, isLoading } = useCanReadSuppliers();
  if (isLoading) return null;
  return <>{allowed ? children : fallback}</>;
}

export default SupplierReadGuard;
